import { Address } from './address';
import { Alert } from './alert';
import { Appointment } from './appointment';
import { DataItem, TouchDate } from './common';
import { Communication } from './communication';
import { Lead } from './lead';
import { PendingRequest } from './pending-request';
import { Problem } from './problem';
import { Quote } from './quote';
import { Task } from './task';
import { TimeZone } from './timezone';

export enum AccountType {
  'Commercial' = 3,
  'Residential' = 5,
}

export const AccountTypes: Record<AccountType, string> = {
  3: 'Commercial',
  5: 'Residential',
};

export type UserData = {
  id: number;
  first_name: string;
  last_name: string;
  company_name: string;
  phone: string;
  work: string;
  cell: string;
  email: string;
  type: {
    id: number;
    name: string;
  };
};

export type BasicUserAccount = UserData & Address;

export type AccountCurrentConversation = {
  id: number;
  type: 'phone' | 'email';
};

export type Account = {
  alerts: Alert[];
  appointments: Appointment[];
  billingAddress: Address;
  category: DataItem;
  cell: string;
  communications: Communication[];
  company: {
    name: string;
  };
  companyName: string;
  created: TouchDate;
  currentConversation?: AccountCurrentConversation[];
  email: string;
  firstName: string;
  id: number;
  lastName: string;
  leads: Lead[];
  location: DataItem & { timezone: TimeZone };
  marketing?: { offersOptIn?: boolean };
  metUrl: string;
  notes: {
    information: string;
    typeOfJunk: string;
    locationOfJunk: string;
    specialInstructions: string;
    movingFactors: string;
    otherNotes: string;
  };
  pendingRequests: PendingRequest[];
  phone: string;
  problems: Problem[];
  quotes: Quote[];
  scorpion?: { id: number };
  source: DataItem;
  type: DataItem;
  tasks: Omit<Task, 'accounts'>[];
  taskComments: Comment[];
  updated: TouchDate;
  work: string;
  featureFlags?: {
    key: string;
    value: string;
  }[];
  selectedServices?: string[];
  /**
   * Free-text promo code captured during online booking (CID-7209).
   * Persisted to the lead's `Requested_Promo_Code` column. Not the same as the
   * validated `coupon` — this is the code the customer claims to have, validated
   * leniently at booking time and re-validated by an agent in the ABT.
   */
  requestedPromoCode?: string;
  tracking?: {
    source?: string;
    medium?: string;
    campaign?: string;
    content?: string;
    term?: string;
  };
  google?: {
    id: string;
  };
  websiteSession?: {
    id: string;
  };
};
